// constants
export const FIX_FLAKY_PIPELINE_TRIGGER_TYPE =
  'pipeline_trigger_fix_flaky_test';
export const FIX_FLAKY_UNAVAILABLE_DISMISSED_KEY =
  'fix-flaky-unavailable-dismissed';
export const FLAKY_SCORE_MIN = 0;
export const FLAKY_SCORE_MAX = 100;
export const FLAKY_DETECTION_FLAKY_SCORE_DEFAULT = 80;
export const QUARANTINE_FLAKY_SCORE_DEFAULT = 90;
export const MINIMUM_TEST_EXECUTIONS_MIN = 1;
export const MINIMUM_TEST_EXECUTIONS_MAX = 250;
export const MINIMUM_TEST_EXECUTIONS_DEFAULT = 10;

// documentation URLs
export const AUTO_FLAKY_DETECTION_LEARN_MORE_URL =
  'https://support.atlassian.com/bitbucket-cloud/docs/understand-and-manage-flaky-tests-in-bitbucket-pipelines/';
export const AUTO_QUARANTINE_LEARN_MORE_URL =
  'https://support.atlassian.com/bitbucket-cloud/docs/quarantining-flaky-tests/';
export const FIX_FLAKY_LEARN_MORE_URL = // TODO TM: update learn more URL
  'https://community.atlassian.com/forums/Bitbucket-articles/Bitbucket-Tests-Introducing-the-Fix-Flaky-test-AI-Agent/ba-p/3228395';
